<div class="mat-typography mat-body mat-app-background">
  <form [formGroup]="deliveryTypeForm" class="dropdown-form">
    <mat-form-field appearance="outline">
      <!-- <mat-label>Delivery Types:</mat-label> -->
      <mat-select formControlName="deliveryOption" [(value)]="selectionChoice">
        @for (option of prescriptionDrugSelectOptions; track option) {
          <mat-option [value]="option.id">
            {{option.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>

  @for (planBenefit of benefitGroup.planBenefits | keyvalue; track planBenefit) {
    <table class="drug-table">
      <!-- PLAN HEADERS -->
      @if (benefitGroup.plans.length > 1) {
        <tr class="shared-bottom-border">
          <td></td>
          <td class="plan-name" [attr.colspan]="'3'">{{getPlanNameByPlanId(planBenefit.key)}}</td>
        </tr>
      }
      <!-- VALUES -->
      <tr class="benefit-headers">
        <td><h3>Tiers</h3></td>
        <td><h3>Initial Coverage Phase</h3></td>
        <td><h3>Gap Coverage Phase</h3></td>
        <td><h3>Catastrophic Coverage Phase</h3></td>
      </tr>
      <tr class="benefit-values even">
        <td class="benefit-name"><span>Preferred Generic</span></td>
        <td>{{benefitGroup.planBenefits[planBenefit.key][selectionChoice].preferredGeneric}}</td>
        <!-- GAP PHASE -->
        <td [attr.rowspan]="'5'">
          <div class="gap-coverage">
            <div><span>Preferred: {{benefitGroup.planBenefits[planBenefit.key].coverageGap.preferred}}</span></div>
            <div class="space-me"><span>Standard: {{benefitGroup.planBenefits[planBenefit.key].coverageGap.standard}}</span></div>
          </div>
        </td>
        <!-- CATASTROPHIC PHASE -->
        <td [attr.rowspan]="'5'">
          <div><span>Preferred: {{benefitGroup.planBenefits[planBenefit.key].catastrophic}}</span></div>
        </td>
      </tr>
      <tr class="benefit-values drug-tier-separator">
        <td class="benefit-name"><span>Generic</span></td>
        <!-- RETAIL AND MAIL have different names -->
        <td>{{benefitGroup.planBenefits[planBenefit.key][selectionChoice].nonPreferredGeneric || benefitGroup.planBenefits[planBenefit.key][selectionChoice].generic}}</td>
      </tr>
      <tr class="benefit-values even drug-tier-separator">
        <td class="benefit-name"><span>Preferred Brand</span></td>
        <td>{{benefitGroup.planBenefits[planBenefit.key][selectionChoice].preferredBrand}}</td>
      </tr>
      <tr class="benefit-values drug-tier-separator">
        <td class="benefit-name"><span>Non-Preferred Drug</span></td>
        <td>{{benefitGroup.planBenefits[planBenefit.key][selectionChoice].nonPreferredBrand}}</td>
      </tr>
      <tr class="benefit-values even drug-tier-separator">
        <td class="benefit-name"><span>Specialty Tier</span></td>
        <!-- RETAIL AND MAIL have different names -->
        <td>{{benefitGroup.planBenefits[planBenefit.key][selectionChoice].preferredSpecialty || benefitGroup.planBenefits[planBenefit.key][selectionChoice].specialty}}</td>
      </tr>
    </table>
  }
</div>
